require('./common.js');

switch (window.entrypoint) {
case 'main':
    main();
    break;
case 'pastemain':
    pastemain();
    break;
case 'landing':
    require('../styles/landing.scss');
    landing();
    break;
default:
    // DIY.
}

function main() {
    var Session = require("session");
    var SessionView = require("sessionview");
    window.SESSION = new Session();
    window.SESSIONVIEW = new SessionView({model: window.SESSION});
    window.SESSION.registerServiceWorker();
    window.SESSION.start();
}

function landing() {
    var Session = require('session');
    var LandingView = require('landingview');
    window.SESSION = new Session();
    window.LANDINGVIEW = new LandingView({model: window.SESSION});
}

function pastemain() {
    var Session = require("session");
    var PastebinView = require("pastebinview");
    window.SESSION = new Session();
    // fetch paste data and display
    window.PASTEVIEW = PastebinView.fromPaste({
        id: window.PASTEID
    }, window.SESSION);
    window.PASTE = window.PASTEVIEW.model;
    window.PASTE.fetch().done(showPaste);
    window.PASTE.bind('removed', function () {
        $('div.pasteContainer').append($('<h2>Pastebin deleted</h2>')).addClass('error');
    });
    window.PASTE.bind('fetchError', function () {
        $('div.pasteContainer').append($('<h2>Error fetching paste</h2>')).addClass('error');
    });
}

function showPaste () {
    if (window.PASTE.get('body')) {
        var pasteEl = $('div.pasteContainer');
        pasteEl.append(window.PASTEVIEW.render({
            standalone: true,
            header: true,
            date: true,
            linkDate: true
        }).el);
    }
}



//////////////////
// WEBPACK FOOTER
// ./app/src/app.js
// module id = WZAx
// module chunks = 3